const SkeletonProductPreview = () => {
  return (
    <div className="animate-pulse bg-white">
      <div className="aspect-square w-full bg-zl-surface" />
      <div className="flex flex-col gap-y-2 p-4 border-t border-zl-line">
        <div className="w-1/4 h-3 bg-zl-surface" />
        <div className="w-3/4 h-5 bg-zl-surface" />
        <div className="w-1/5 h-5 bg-zl-surface mt-2" />
      </div>
    </div>
  )
}

export default SkeletonProductPreview
